<div class="form-panel-container crud {{ className }}">
    <app-advanced-gridview
        [dataSource]="dataSource"
        [readOnly]="readOnly"
        [size]="100"
        [model]="tableModel"
        [menuItems]="menuItems"
        [contextualMenu]="tableModel.columnActionVisible"
        [sortEnabled]="sortEnabled"
        (menuClicked)="onAction($event)"
        (rowDoubleClicked)="onRowDoubleClick($event)"
        (itemsSorted)="onItemsSorted($event)"></app-advanced-gridview>
    <div class="buttons-container">
        @if (!readOnly) {
            <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); onRecordsExported()">Exporter</button>
            @if (enumHelper.areNotEquals(FormMode, _context.mode, FormMode.Reading)) {
                <button mat-raised-button class="accent-button" (click)="$event.stopPropagation(); fileToUpload.click()">Importer</button>
                @if (memoryService.getConnectedUser().hasRight(getCreationRight())) {
                    <button mat-raised-button class="accent-button" (click)="onCreate()">Ajouter</button>
                }
            }
        }

        <input ng2FileSelect #fileToUpload class="file-to-upload" type="file" [uploader]="uploader" (change)="onFileSelected()" [hidden]="true" />
    </div>
    <ngx-spinner name="detail-spinner" bdColor="var(--spinner-background-color)" color="var(--spinner-color)" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
</div>
